<template>
  <div v-show="accordionVisible">
    <div :id="`heading-${identifier}`" :class="headerClass">
      <button class="btn btn-block btn-lg p-0 border-0" :class="[(loopIndex === 0 && firstElementShown) ? '' : 'collapsed' , (showCollapseIcons && !isPreview) ? 'position-relative' : '']" data-toggle="collapse" :data-target="`#content-${identifier}`" :aria-expanded="[(loopIndex === 0 && firstElementShown)]" :aria-controls="`content-${identifier}`">
        <slot name="header"></slot>
        <div v-if="showCollapseIcons && !isPreview" class="position-absolute d-flex" :class="alignmentIconClass" style="top: 0;right: 0;bottom: 0;left: 0;">
          <i :class="[ (loopIndex === 0 && firstElementShown) ? iconActiveClass : iconClosedClass, customIconClass]" class="fa m-3"/>
        </div>
      </button>
    </div>
    <div :id="`content-${identifier}`" ref="myBody" class="collapse" :class="[(loopIndex === 0 && firstElementShown) ? 'show' : '' ,]" :aria-labelledby="`heading-${identifier}`" :data-parent="[(behavior === 'showOneCollapseRest') ? `#${accordionId}` : '']">
      <slot name="body"></slot>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      headerClass: String,
      identifier: String,
      showCollapseIcons: Boolean,
      isPreview: Boolean,
      alignmentIconClass: String,
      iconActiveClass: String,
      iconClosedClass: String,
      loopIndex: Number,
      firstElementShown: Boolean,
      customIconClass: String,
      behavior: String,
      accordionId: String
    },
    data () {
      return {
        accordionVisible: true,
        observer: null
      }
    },
    mounted () {
      this.$nextTick(() => { // https://es.vuejs.org/v2/api/index.html#Vue-
        // Code that will run only after the
        // entire view has been re-rendered

        const context = this;
        this.observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            // console.log('Mutando', mutation.type);
            const bodyContent = document.getElementById(`content-${context.identifier}`)
            // console.log('BodyContent Mutated: ', bodyContent.textContent.trim().length)
            context.accordionVisible = bodyContent.textContent.trim().length > 0 || bodyContent.querySelector('img, iframe, picture')

          });
        }.bind(this));

        let config = { attributes: true, childList: true, characterData: true, subtree: true };
        let target =document.getElementById(`content-${this.identifier}`)
        // Setup the observer
        this.observer.observe(target, config);

        const bodyContent = document.getElementById(`content-${this.identifier}`)
        // console.log('bodycontent: ', bodyContent.textContent.trim().length)
        if (!this.isPreview) {
          this.accordionVisible = bodyContent.textContent.trim().length > 0 || bodyContent.querySelector('img, iframe, picture')
        }

        if (this.showCollapseIcons && !this.isPreview) {
          // Se tienen que declarar antes las referencias de los props, para poder usarlos en Jquery
          const element = document.getElementById(`heading-${this.identifier}`)
          const iconClassHide = this.iconClosedClass
          const iconClassShow = this.iconActiveClass
          $(this.$refs.myBody).on('hide.bs.collapse', function () {
            element.firstChild.lastChild.firstChild.classList.replace(iconClassShow, iconClassHide)
          })
          $(this.$refs.myBody).on('show.bs.collapse', function () {
            element.firstChild.lastChild.firstChild.classList.replace(iconClassHide, iconClassShow)
          })
        }
      })
    },
    updated() {
      // console.log('Updated Fired');
      const bodyContent = document.getElementById(`content-${this.identifier}`)
      // console.log('BodyContent Updated: ', bodyContent.textContent.trim().length)
      this.accordionVisible = bodyContent.textContent.trim().length > 0 || bodyContent.querySelector('img, iframe, picture')

    },

    beforeDestroy() {
      // Clean up
      this.observer.disconnect();
    }
  }
</script>
